import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  private connectionSubj$ = new BehaviorSubject<boolean | null>(null);
  public onLine$: Observable<boolean | null> =
    this.connectionSubj$.asObservable();

  constructor() {
    window.addEventListener('online', () => {
      this.connectionSubj$.next(true);
    });
    window.addEventListener('offline', () => {
      this.connectionSubj$.next(false);
    });
  }
}
